import React from 'react';

/**
 * The two app-store glyphs, shared by the `/download` page and the footer/home
 * `AppDownload` promo. Both used to carry private copies; the Play mark in
 * particular defines four `<linearGradient>` ids, and two copies on one page
 * (home renders `AppDownload`, `/download` renders the store cards) meant
 * duplicate SVG ids in the same document. One module, one definition.
 */

export const AppleIcon: React.FC<{ size?: number }> = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden fill="currentColor">
    <path d="M16.365 1.43c0 1.14-.49 2.27-1.27 3.08-.84.86-2.16 1.52-3.27 1.43-.13-1.1.41-2.27 1.18-3.05.84-.86 2.27-1.5 3.36-1.46zM20.5 17.07c-.55 1.27-.81 1.83-1.52 2.95-.99 1.55-2.39 3.49-4.13 3.5-1.55.02-1.95-1.01-4.05-1-2.1.01-2.54 1.02-4.09 1-1.74-.01-3.07-1.76-4.06-3.32C-.07 16.6.43 11.7 3.39 9.92c1.05-.62 2.27-.93 3.45-.93 1.55 0 2.5.85 3.78.85 1.24 0 1.98-.85 3.78-.85 1.36 0 2.81.74 3.84 2.02-3.36 1.84-2.81 6.66.26 6.06z" />
  </svg>
);

export const PlayIcon: React.FC<{ size?: number }> = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden>
    <defs>
      <linearGradient id="play-grad-1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#34a4ff" />
        <stop offset="100%" stopColor="#1c66c0" />
      </linearGradient>
      <linearGradient id="play-grad-2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ff8a00" />
        <stop offset="100%" stopColor="#e52e71" />
      </linearGradient>
      <linearGradient id="play-grad-3" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffd000" />
        <stop offset="100%" stopColor="#ff7f00" />
      </linearGradient>
      <linearGradient id="play-grad-4" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0fdb48" />
        <stop offset="100%" stopColor="#00be3a" />
      </linearGradient>
    </defs>
    <path d="M3.5 2.7v18.6c0 .26.13.5.34.65l9.36-9.95L3.84 2.05a.78.78 0 0 0-.34.65z" fill="url(#play-grad-1)" />
    <path d="M16.43 8.78L13.2 12l3.23 3.22 4.04-2.32c.94-.54.94-1.86 0-2.4l-4.04-2.32z" fill="url(#play-grad-3)" />
    <path d="M3.84 2.05l9.36 9.95 3.23-3.22L4.83 1.78a.79.79 0 0 0-.99.27z" fill="url(#play-grad-4)" />
    <path d="M3.84 21.95l9.36-9.95-3.23 3.22 6.6 7-1.32-2.27z" fill="url(#play-grad-2)" />
  </svg>
);
